import React from 'react'

import PropTypes from 'prop-types'

import { useReduxLocation } from 'navigation'

import Stack from 'Stack'
import { NOT_FOUND } from 'redux-first-router'
import RootPages from 'RootPages'
import Toasts from 'toasts/Toasts'
import CssBaseline from '@material-ui/core/CssBaseline'
import { useProfile } from 'profile/profile.selectors'
import { SetupPushNotifications, logToNative, GlobalCss, useInitGTag, useGTagPageView, AppComponentsContextProvider } from 'lib-core'
import { useInstance } from 'navigation/instance.selectors'
import { useUnmount } from 'ahooks'
import { StyledIcon } from 'components/StyledIcon'



const AppRouter = (props) => {
  const reduxLocation = useReduxLocation()

  const { type } = reduxLocation
  if (type !== NOT_FOUND) {
    return <Stack {...props}></Stack>
  }

  return <RootPages />
}



const App = () => {
  const { profile } = useProfile()
  const instance = useInstance()

  useInitGTag(instance?.value?.gaTrackingId)
  useGTagPageView()
  useUnmount(() => {
    console.log("lifecycle: app unmount")
  })

  return (
    <AppComponentsContextProvider CardIcon={StyledIcon}>
      <GlobalCss />
      <SetupPushNotifications profile={!!profile} />
      <CssBaseline />
      <Toasts />
      <AppRouter />
    </AppComponentsContextProvider>
  )
}

export const appContextType = {
  api: PropTypes.object
}


export default App